import React from 'react';

/**
 * SVG sticker renderer.
 *
 * Two modes:
 *  - Recolorable ("svg"): rendered via CSS `mask-image` so the fill is driven
 *    by `background-color`. This avoids CORS issues from fetching cross-origin
 *    SVG text (which `<img>` requests don't hit).
 *  - Plain ("simple_svg"): rendered via a plain `<img>` tag preserving the
 *    original SVG colors.
 */

interface SvgStickerProps {
  url: string;
  /** If provided, the sticker is tinted with this color using CSS mask. */
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const SvgSticker: React.FC<SvgStickerProps> = ({ url, color, className, style }) => {
  if (color) {
    const maskStyle: React.CSSProperties = {
      width: '100%',
      height: '100%',
      backgroundColor: color,
      WebkitMaskImage: `url("${url}")`,
      maskImage: `url("${url}")`,
      WebkitMaskRepeat: 'no-repeat',
      maskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      maskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskSize: 'contain',
      ...style,
    };
    return <div className={className} style={maskStyle} />;
  }

  return (
    <img
      src={url}
      alt=""
      draggable={false}
      className={className}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        display: 'block',
        pointerEvents: 'none',
        ...style,
      }}
    />
  );
};

export default SvgSticker;
